import {getServerTexts as getTexts, initTexts, texts} from '../../Localization/texts';

const entity = 'UI_PRINTDIALOG';

const en = {
    formatTitle: 'Choose Format',
    html: 'HTML',
    htmlHelp:
        'You can create documents in one of two formats:\n- Using a format based on a Word Template, which is customizable and displayed in Word.\n- An HTML-based format, which is predefined and can be displayed in your browser.\n\nEither format can also be created as a PDF file by flagging the PDF File option at the bottom of this window.',
    format: 'Template',
    formatHelp:
        'A format that can be customized in Word, can be displayed in Word or as a PDF (by flagging "PDF File").',
    print: 'Print',
    printTooltip:
        'Print the document. You can print automatically, without choosing a printer, by flagging the Quick Print option.',
    show: 'Display',
    showTooltip:
        'Displaying the document in your browser or as a Word file, according to the selected format.',
    mail: 'Mail',
    quickMail: 'Quick Email',
    mailTooltip: 'Send the certificate as an email attachment',
    quickMailTooltip:
        "Send the document as an attachment to the contact's email without opening the email input window.",
    fax: 'Automatic Fax',
    faxTooltip: "Send the document directly to the contact's fax.",
    quickPrint: 'Quick Print',
    quickPrintTooltip:
        'When flagged, the document will print immediately, without having to select a printer.',
    pdfFile: 'PDF File',
    pdfTooltip: 'When flagged, a PDF file that can be saved will be created.',
    attachment: 'Include Attachments',
    attachmentTooltip: "When flagged, the document's attachments will also be printed.",
    customize: 'Customize',
    copies: 'No. of Copies',
    typeSelectTitle: 'What do you want to do with the document?',
    fromatSearch: 'Search format by name',
    apply: 'Apply',
    noResults: "We couldn't find results for the value you were looking for."
};

const he = {
    formatTitle: 'בחירת פורמט',
    html: 'HTML',
    htmlHelp:
        'פריוריטי מאפשרת לך להפיק מסמכים בשני פורמטים:\n- פורמט המבוסס על תבנית Word הניתנת להתאמה אישית ולהצגה בתוכנת Word.\n- פורמט מבוסס HTML המוגדר מראש ומוצג בתוך הדפדפן.\n\nאת שני הפורמטים ניתן להפיק כקובץ PDF אם מסמנים את האפשרות "קובץ PDF" בתחתית חלון זה.',
    format: 'תבנית',
    formatHelp:
        'בפורמט הניתן לעריכה עם Word, ניתן להצגה ב-Word או כ-PDF (ע"י סימון האפשרות "קובץ PDF").',
    print: 'הדפסה',
    printTooltip:
        'שליחת התעודה להדפסה. ניתן להדפיס מידית, ללא בחירת מדפסת, ע"י סימון האפשרות "הדפסה מהירה".',
    show: 'הצגה',
    showTooltip: 'הצגת התעודה בדפדפן או בקובץ Word, לפי סוג הפורמט הנבחר.',
    mail: 'דואר',
    mailTooltip: 'שליחת התעודה בקובץ מצורף לאימייל.',
    quickMail: 'מייל מהיר',
    quickMailTooltip: 'שליחת התעודה כקובץ מצורף למייל של איש הקשר. אין צורך לפתוח את תיבת המייל.',
    fax: 'פקס אוטומטי',
    faxTooltip: 'שליחת התעודה ישירות לפקס של איש הקשר.',
    quickPrint: 'הדפסה מהירה',
    quickPrintTooltip: 'כשמסומן, התעודה תודפס מיד, ללא בחירת מדפסת.',
    pdfFile: 'קובץ Pdf',
    pdfTooltip: 'כשמסומן, יופק קובץ PDF שניתן לשמור.',
    attachment: 'נספחים',
    attachmentTooltip: 'כשמסומן, יודפסו גם הנספחים של התעודה.',
    customize: 'התאמה אישית',
    copies: 'מספר עותקים',
    typeSelectTitle: 'מה ברצונך לעשות עם המסמך?',
    fromatSearch: 'חיפוש פורמט לפי שם',
    apply: 'אישור',
    noResults: '.לא הצלחנו למצוא תוצאות עבור הערך שחפשת'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'formatTitle',
    2: 'html',
    3: 'htmlHelp',
    4: 'format',
    5: 'formatHelp',
    6: 'print',
    7: 'printTooltip',
    8: 'show',
    9: 'showTooltip',
    10: 'mail',
    11: 'mailTooltip',
    12: 'quickMail',
    13: 'quickMailTooltip',
    14: 'fax',
    15: 'faxTooltip',
    16: 'quickPrint',
    17: 'quickPrintTooltip',
    18: 'pdfFile',
    19: 'pdfTooltip',
    20: 'attachment',
    21: 'attachmentTooltip',
    22: 'customize',
    23: 'copies',
    24: 'typeSelectTitle',
    25: 'fromatSearch',
    26: 'apply',
    27: 'noResults'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
